import * as React from 'react';
import { TableProps } from 'semantic-ui-react';
import '../css/table.sass';

export default function TH(props: TableProps) {
  const { className, ...other } = props; // eslint-disable-line @typescript-eslint/no-unused-vars
  const userClass = className ? `campfire-th ${className}` : 'campfire-th';
  return (
    <th className={userClass} {...other}>
      {props.children}
    </th>
  );
}
